import { LoginRequiredError } from "@workos-inc/authkit-react";
import { OfflineError } from "@/lib/api";

/**
 * The error classes the Sentry `beforeSend` filter treats as *expected* and
 * drops. This is the single shared definition: `dropExpectedEvents` (the filter
 * in `instrument.ts`) and `reportBoundaryError` (the `QueryErrorBoundary` crash
 * reporter) both use it, so the two never drift on what "expected" means.
 *
 *  - `OfflineError` — thrown by `apiFetch` when the device has no connectivity.
 *  - `LoginRequiredError` — thrown by WorkOS `getAccessToken()` when no session
 *    is held (auth not yet hydrated on a cold boot, or a session needing
 *    re-login); the AuthGuard, not Sentry, drives the recovery.
 *
 * "Expected" means *failing as designed*. An expected error that instead
 * crashes the UI is a bug — see `specs/conventions/error-reporting.md`.
 */
export function isExpectedError(error: unknown): boolean {
  return error instanceof OfflineError || error instanceof LoginRequiredError;
}
